import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const ContainerLoader = styled.div`
  width: 100%;
  height: 700px;
  background-color: ${colors.bg['soft-200']};
  opacity: 0.4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  p {
    opacity: 1;
  }
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 1000px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
  background-color: white;
  margin-top: 16px;
`;

export const BottomLayer = styled.div`
  position: absolute;
  bottom: -20px;
  left: 0;
  width: 100%;
  height: 80px;
  background-color: white;
  pointer-events: auto;
`;

export const ButtonExport = styled.button`
  color: ${colors.brand.principal};
  border: 1px solid ${colors.brand.principal};
  border-radius: 4px;
  background-color: ${colors.White};
  padding: 0 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 33px;
  font-weight: 600;
  gap: 6px;
  &:hover {
    cursor: pointer;
    background-color: ${colors.Blue050};
    border: 1px solid transparent;
  }
`;
